import React, { useState } from 'react';

import IconSearch from '@/assets/Icon/svg/Search';
import Typography from '@/components/Typography';

import { styInputSearch } from '../style';

const useSelectSearch = (props) => {
  const {
    id,
    options,
    displayOptions,
    setDisplayOptions,
    props: { searchByApi, onSearchChange, placeholderSearch },
  } = props;

  const [keyword, setKeyword] = useState('');
  const resetSearch = () => setKeyword('');

  const handleChangeSearch = (e) => {
    e.preventDefault();
    setKeyword(e.target.value);
    if (!searchByApi) {
      const filteredOptions = options.filter(
        (opt) => opt.text.toLowerCase().includes(e.target.value.toLowerCase())
          || opt.value.toLowerCase().includes(e.target.value.toLowerCase()),
      );
      setDisplayOptions(filteredOptions);
    }
    if (onSearchChange) onSearchChange(e.target.value);
  };

  const renderSearch = () => (
    <>
      <div className={styInputSearch}>
        <input
          value={keyword}
          placeholder={placeholderSearch}
          onChange={handleChangeSearch}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          data-testid={`${id}-search`}
        />
        <IconSearch />
      </div>
      {displayOptions.length === 0 && (
        <div style={{ padding: 8 }}>
          <Typography type="label" margin={0} data-testid="divNotFound">
            Data tidak ditemukan
          </Typography>
        </div>
      )}
    </>
  );

  return { resetSearch, renderSearch };
};

export default useSelectSearch;
